import axios from 'axios'
import { REPORT_URL, DASHBOARD_URL } from './api'
import { authorizationHelper } from '../common/helpers'

export function getFranchiseDetail(month, year, page, size) {
    const params = {
        month,
        year,
        page,
        size,
    }

    const url = `${REPORT_URL}/franchise`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

//#region Dashboard
export function getTopCustomers(startDate, endDate, store) {

    const params = {
        begin: startDate,
        finish: endDate,
        store,
    }

    const url = `${REPORT_URL}/topclients`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })

}

export function getAverageTicket(startDate, endDate, store) {

    const params = {
        startDate,
        endDate,
        store,
    }

    const url = `${DASHBOARD_URL}/averageticket`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })

}

export function getNewClients(startDate, endDate, store) {

    const params = {
        startDate,
        endDate,
        store,
    }

    const url = `${DASHBOARD_URL}/newclients`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })

}

export function getSellsByDay(month, year, store) {

    const params = {
        month,
        year,
        store
    }

    const url = `${DASHBOARD_URL}/sellsbydays`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })

}

export function getSellsByHour(requestDate, store, state) {

    const params = {
        requestDate,
        store,
        state,
    }

    const url = `${DASHBOARD_URL}/sellsbyhour`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })

}

export function getSellsByMonth(year, store) {

    const params = {
        year,
        store,
    }

    const url = `${DASHBOARD_URL}/sellsbymonth`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })

}

export function getSellsTopEmployees(startDate, endDate, store) {

    const params = {
        startDate,
        endDate,
        store,
    }

    const url = `${DASHBOARD_URL}/topemployees`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })

}

export function getSellsTopCategories(startDate, endDate, store) {

    const params = {
        startDate,
        endDate,
        store,
    }

    const url = `${DASHBOARD_URL}/topcategories`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })

}

export function getStoreVisitor(startDate, endDate, store) {

    const params = {
        begin: startDate,
        finish: endDate,
        store,
    }

    const url = `${DASHBOARD_URL}/topvisitors`

    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })

}
//#endregion


// WEBPACK FOOTER //
// ./src/service/dashboard.js